import { request, success, failure, SALARY_REQUEST } from './utilities';
import { getAllSalaries } from '../api';
import { data } from './SalaryData';

export function getSalaryList() {
    return (dispatch) => {
        dispatch(request(SALARY_REQUEST.GET_SALARY_REQUEST));
        dispatch(success(SALARY_REQUEST.GET_SALARY_SUCCESS, data));
        // getAllSalaries().then(
        //     response=>{
        //         if (response.data.message === "Success") {
        //             dispatch(success(SALARY_REQUEST.GET_SALARY_SUCCESS, response.data.data))
        //         }
        //         else {
        //             dispatch(failure(SALARY_REQUEST.GET_SALARY_FAILURE, response.data.message))
        //         }
        //     },
        //     error => {
        //         dispatch(failure(SALARY_REQUEST.GET_SALARY_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        //     }
        // )
    }
}